// A refusal the panel shows in plain words (2026-10-28): a 409 from the
// decision route (Send, Escalate, Close), the step routes (Process) or Spam
// that the panel has no handling of its own for shows the server's message,
// else "<Action> was refused: <error>", never the request path and status
// ("/api/ai/suggestions/... -> 409"). Any other failure keeps its message.

export function refusalMessage(e, action = 'Send') {
  const body = e?.body ?? null
  if (typeof body?.message === 'string' && body.message.trim()) return body.message
  if (typeof body?.error === 'string' && body.error) return `${action} was refused: ${body.error}`
  return `${action} was refused.`
}

export function errorText(e, action = 'Send') {
  return e?.status === 409 ? refusalMessage(e, action) : (e?.message ?? String(e))
}

// The action a decision status stands for, for the sentences above.
export function decisionActionName(status) {
  return { approved: 'Send', edited: 'Send', escalated: 'Escalate', transferred: 'Transfer', dismissed: 'Close' }[status] ?? 'Send'
}
